module.exports = __webpack_public_path__ + "img/10 - Condominio_das_Americas_MiniCampo.e2075a8b.jpg";